<template>
    <transition
        v-if="accountDetails"
        enter-active-class="ease-out duration-300"
        enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        enter-to-class="opacity-100 translate-y-0 sm:scale-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100 translate-y-0 sm:scale-100"
        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
        <div v-show="show"
             class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6"
             role="dialog" aria-modal="true" aria-labelledby="modal-headline">
            <div>
                <div :class="`mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-${$root.theme}-100`">
                    <svg :class="`h-8 w-8 text-${$root.theme}-600`" xmlns="http://www.w3.org/2000/svg" fill="none"
                         viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2"/>
                    </svg>
                </div>
                <div class="mt-3 sm:mt-5">
                    <h3 class="text-lg text-center leading-6 font-medium text-gray-900" id="modal-headline">
                        Account Details
                    </h3>
                    <div class="mt-2">
                        <p class="text-sm text-gray-500 mb-2" v-html="accountDetails"/>
                    </div>
                </div>
            </div>
            <div class="mt-5 sm:mt-6">
                <button @click="close" type="button"
                        :class="`inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-${$root.theme}-300 text-base font-medium text-white hover:bg-${$root.theme}-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-${$root.theme}-300 sm:text-sm`">
                    Close
                </button>
            </div>
        </div>
    </transition>
</template>

<script>
import Mixins from '../../mixins';

export default {
    mixins: [Mixins],

    props: ['show', 'account-details', 'just-details'],

    watch: {
        show(show) {
            if (!this.accountDetails) {
                this.close();
            }

            if (show) this.gtagEvent('show-account-details:offers-page');
        }
    },

    methods: {
        close() {
            this.$emit('close');

            if (!this.justDetails) {
                this.$emit('after');
            }
        }
    }
}
</script>
